import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Page from '../../component/Page'
import { getData } from '../../services/api'

export default function Role() {
  const [data, setData] = useState([])

  useEffect(() => {
    getData('dbms/admin-roles').then((response) => setData(response.result))
  }, [])
  return (
    <Page>
      <div class="container-fluid">

        <div class=" d-flex row justify-content-between align-items-baseline">
          <div class="col-lg-4 col-md-12 text-left ">
            <label class="title-content mb-4">
              รายการกลุ่มผู้ใช้งานระบบ
            </label>
          </div>

        </div>

        <div class="listData row">
          <div class="col-md-12 table-responsive-sm pb-3">
            <table class="table table-borderless table-hover ">
              <thead>

                <tr>
                  <th class="text-center" >no.</th>
                  <th class="text-center" >ชื่อกลุ่ม</th>
                  <th class="text-center" >สถานะ</th>
                  <th class="text-center" ></th>

                </tr>
              </thead>
              <tbody class="cp">
                {data?.map((x, i) => (
                  <tr>
                    <td class="text-center">{i + 1}.</td>
                    <td class="text-center">{x?.RoleName}</td>
                    <td class="text-center">
                      {
                        x?.Status === 'Y' ?
                          <span class="status-active">
                            ใช้งาน
                          </span> :
                          <span class="status-inactive">
                            ไม่ใช้งาน
                          </span>}
                    </td>
                    <td class="text-center">
                      <Link to={`/setting/role/${x?.RoleId}`}>
                        <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                      </Link>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div >
          <div class="col-md-12 text-center mt-4">
            {/* <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={page} onChange={(event, value) => setPage(value)} shape="rounded" /> */}
          </div >
        </div >
      </div >
    </Page >
  )
}
